/**
*
* Spinner
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import FaSpinner from 'react-icons/lib/fa/spinner';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import styles from './styles.css';

const Spinner = ({ text }) => (
  <div className={styles.spinner}>
    <FaSpinner className={styles.iconSpin} />
    { text }
  </div>
);

Spinner.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

Spinner.defaultProps = {
  text: <FormattedMessage {...messages.loading} />,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js